import React from 'react'
import { Text } from '@retailer-platform/shared-components'
import { type PipelineStep } from '../../../../../../types/attributeManagement.types'
import { PipelineNodeCardPill } from '../PipelineEditorNode'
import { useDomainMessages } from '../../../../../../utils/domain/intl'
import { CampFieldsContainer, IndentedText } from './ControlOverviewPane'

interface FieldMatchPaneProps {
  step: PipelineStep
}

const FieldMatchPane: React.FC<FieldMatchPaneProps> = ({ step }) => {
  const i18n = useDomainMessages({
    campFields:
      'catalogAdminDomain.attributeManagement.stepAttributeForms.pipelineForm.controlFieldMatch.campFields',
    winningValueOutputField:
      'catalogAdminDomain.attributeManagement.stepAttributeForms.pipelineForm.controlFieldMatch.winningValueOutputField',
    countsRequired:
      'catalogAdminDomain.attributeManagement.stepAttributeForms.pipelineForm.controlFieldMatch.countsRequired',
    notApplicable:
      'catalogAdminDomain.attributeManagement.stepAttributeForms.pipelineForm.controlFieldMatch.notApplicable',
  })

  return (
    <PipelineNodeCardPill>
      <CampFieldsContainer>
        <Text size={'small'} weight="semibold">
          {i18n.campFields}
        </Text>
        <IndentedText size={'small'} weight="regular">
          {step.nextStepsRule?.campFields
            ?.map(field => field.trim())
            .filter(field => field)
            .join(', ')}
        </IndentedText>
        <Text size={'small'} weight="semibold">
          {' '}
          {i18n.winningValueOutputField}{' '}
        </Text>
        <IndentedText size={'small'} weight="regular">
          {step.nextStepsRule?.winningValueOutputField?.trim() ?? i18n.notApplicable}
        </IndentedText>
        <Text size={'small'} weight="semibold">
          {' '}
          {i18n.countsRequired}{' '}
        </Text>
        <IndentedText size={'small'} weight="regular">
          {step.nextStepsRule?.countRequired ?? i18n.notApplicable}
        </IndentedText>
      </CampFieldsContainer>
    </PipelineNodeCardPill>
  )
}

export default FieldMatchPane
